import * as React from 'react';
import CallToAction from '../../../containers/CallToAction';
import useTranslation from '../../../hooks/useTranslation';
import StatsControls from '../../../containers/StatsControls';

const GuiHeader = ( props: { serverTime: string, matchid: number, showStatsControls: boolean } ) => {
    const headerMatchText = useTranslation('Header_match');
    return (
        <div className="sr-grid sr-row-sr-align-center guiHeader">
            <div className="sr-cell sr-xs-1-5 sr-show-up-to-m">
                <div className="sr-content">
                    <div></div>
                </div>
            </div>
            <div className="sr-cell sr-l-3-4 sr-hide-up-to-s sr-cell-align-center">
                <div className="sr-content sr-align-center">
                    <div><CallToAction /></div>
                </div>
            </div>
            <div className="sr-cell sr-show-up-to-s sr-cell-align-center">
                <div className="sr-content sr-align-center">
                    <div className="ambassador mobile"></div>
                    <div className="textWrapperAndCountdown">
                        <div className="textWrapper-mobile">
                            <div className="matchIndicator-date mobile">{props.serverTime}</div>
                            <span>-</span>
                            <div className="matchIndicator-match mobile">{props.matchid}</div>
                        </div>
                        <div><CallToAction /></div>
                    </div>
                </div>
            </div>
            <div className="sr-cell sr-m-1-4 sr-l-1-4 sr-hide-up-to-s sr-cell-align-center">
                <div className="sr-content sr-align-right matchIndicator">
                    <div className="ambassador"></div>
                    <div className="textWrapper">
                        <div className="matchIndicator-date">{props.serverTime}</div>
                        <div className="matchIndicator-match">{headerMatchText} {props.matchid}</div>
                    </div>
                </div>
            </div>
            <div className="sr-cell sr-xs-1-5 sr-show-up-to-s sr-cell-align-center">
                <div className="sr-content sr-align-right">
                    {props.showStatsControls&&<StatsControls direction='horizontal' />}
                </div>
            </div>
        </div>
    )
}

export default GuiHeader;
